
import { Auth } from "./auth.js";
import { loadStoredSalesData } from "./orders_data.js";
import { syncBatch, saveOrderToServer } from "./orders_api.js";
import { applyProductMappings } from "./orders_render.js";
import { renderChatMessages } from "./chat.js";


var syncCompleted = false;
var _syncNewCount = 0;
var _syncUpdateCount = 0;
var _syncPendingPromises = [];
var __efastProgressInterval = null;
/**
 * Efast Workbench - 阿里国际站同步 + 扩展事件处理
 * 从 sales_logic.js 拆分
 */

// ===== 全局通知闪烁 =====
function flashGlobalNotification() {
    const badge = document.getElementById("global-badge");
    if (badge) {
        let count = parseInt(badge.innerText) || 0;
        badge.innerText = count + 1;
        badge.style.transform = "scale(1.3)";
        setTimeout(function() { badge.style.transform = ""; }, 300);
    }
}

window.isSyncing = false;
window.syncCompleted = false;
window.__efastProgressInterval = null;
function _showSyncToast(msg, type) {
    type = type || "info";
    var bg = type === "error" ? "#fef2f2" : type === "warn" ? "#fffbeb" : "#f0fdf4";
    var border = type === "error" ? "#fecaca" : type === "warn" ? "#fde68a" : "#bbf7d0";
    var color = type === "error" ? "#dc2626" : type === "warn" ? "#d97706" : "#16a34a";
    var icon = type === "error" ? "fa-circle-exclamation" : type === "warn" ? "fa-triangle-exclamation" : "fa-circle-check";
    var div = document.createElement("div");
    div.style.cssText = "position:fixed;top:16px;right:16px;background:"+bg+";border:1.5px solid "+border+";color:"+color+";padding:10px 18px;border-radius:10px;font-size:13px;font-weight:600;z-index:99999;box-shadow:0 4px 20px rgba(0,0,0,0.12);animation:syncToastIn 0.3s ease;max-width:400px;";
    div.innerHTML = "<i class=\"fa-solid "+icon+"\" style=\"margin-right:8px;\"></i>" + msg;
    document.body.appendChild(div);
    setTimeout(function(){ div.style.opacity="0"; div.style.transition="opacity 0.3s"; setTimeout(function(){ div.remove(); }, 300); }, 3000);
}

window._pendingSyncSaves = [];
window._pendingSyncOrders = [];
window._efastBridgeReady = false;

var __latestExtensionVersion = null;
var __extensionVersionReceived = false;
var __extensionCheckStarted = false;
var __extensionVersionTimedOut = false;
var __pendingExtensionActual = null;

function _compareExtensionVersion(a, b) {
    var pa = String(a || "0").split(".").map(function (x) { return parseInt(x, 10) || 0; });
    var pb = String(b || "0").split(".").map(function (x) { return parseInt(x, 10) || 0; });
    for (var i = 0; i < Math.max(pa.length, pb.length); i++) {
        var na = pa[i] || 0;
        var nb = pb[i] || 0;
        if (na !== nb) return na < nb ? -1 : 1;
    }
    return 0;
}

function _removeExtensionUpdateBanner() {
    var old = document.getElementById("efast-extension-update-banner");
    if (old) old.remove();
}

function _showExtensionUpdateBanner(currentVersion, latestVersion) {
    _removeExtensionUpdateBanner();
    var banner = document.createElement("div");
    banner.id = "efast-extension-update-banner";
    banner.style.cssText = "position:fixed;top:0;left:0;right:0;z-index:2147483647;background:#b91c1c;color:#fff;padding:10px 48px 10px 16px;font-size:14px;font-weight:600;box-shadow:0 4px 16px rgba(0,0,0,.2);";
    var latest = latestVersion || __latestExtensionVersion || "";
    var text = currentVersion ? ("检测到插件版本 v" + currentVersion + "，请更新到 v" + latest + "。") : ("未检测到最新版国际站联动插件，请安装/更新到 v" + latest + "。");
    banner.innerHTML = "⚠️ " + text + " 更新方式：Chrome 地址栏输入 chrome://extensions，打开右上角“开发者模式”，点击扩展卡片的“重新加载”。";
    var close = document.createElement("span");
    close.innerText = "✕";
    close.style.cssText = "position:absolute;right:12px;top:50%;transform:translateY(-50%);cursor:pointer;font-size:18px;line-height:1;";
    close.onclick = function () { banner.remove(); };
    banner.appendChild(close);
    document.body.appendChild(banner);
}

function _evaluateExtensionVersion(actualVersion) {
    var latest = __latestExtensionVersion;
    if (latest === null) {
        __pendingExtensionActual = actualVersion;
        return;
    }
    __pendingExtensionActual = null;
    if (!actualVersion || _compareExtensionVersion(actualVersion, latest) < 0) {
        _showExtensionUpdateBanner(actualVersion, latest);
    } else {
        _removeExtensionUpdateBanner();
    }
}

function _requestExtensionVersion() {
    try {
        window.postMessage({ source: "efast_request_extension_version" }, "*");
    } catch (e) {}
}

function _startExtensionVersionCheck() {
    if (__extensionCheckStarted) return;
    __extensionCheckStarted = true;
    fetch("/api/extension-version")
        .then(function (r) { return r.ok ? r.json() : { version: "" }; })
        .then(function (data) {
            __latestExtensionVersion = data && data.version ? String(data.version) : "";
            if (__extensionVersionReceived) {
                _evaluateExtensionVersion(__pendingExtensionActual || "");
            } else if (__extensionVersionTimedOut) {
                _evaluateExtensionVersion("");
            } else {
                _requestExtensionVersion();
                if (window._efastBridgeReady) _requestExtensionVersion();
                // 兜底：6 秒内既没收到插件握手、也没拿到版本号 → 视为插件缺失或插件未注入本域名（旧版），直接提醒升级
                setTimeout(function () {
                    if (!__extensionVersionReceived) {
                        __extensionVersionTimedOut = true;
                        _evaluateExtensionVersion("");
                    }
                }, 6000);
            }
        })
        .catch(function () {
            __latestExtensionVersion = "";
            if (!__extensionVersionReceived) {
                __extensionVersionTimedOut = true;
                _evaluateExtensionVersion("");
            }
        });
}

window.addEventListener("message", function (event) {
    if (event.data && event.data.source === "efast_extension_version") {
        __extensionVersionReceived = true;
        _evaluateExtensionVersion(event.data.version || "");
    }
});
window.addEventListener("message", function (event) {
    if (event.data && event.data.source === "efast_bridge_ready") {
        window._efastBridgeReady = true;
        if (!__extensionVersionReceived) {
            _requestExtensionVersion();
            setTimeout(function () {
                if (!__extensionVersionReceived) {
                    __extensionVersionTimedOut = true;
                    _evaluateExtensionVersion("");
                }
            }, 5000);
        }
    }
});

_startExtensionVersionCheck();
function initAlibabaSync() {
    const consoleLog = document.getElementById("sync-console-log");
    if (consoleLog) {
        consoleLog.innerHTML = `<p class="console-line">[${new Date().toLocaleTimeString()}] 数据网关已就绪。连接账号: samson@efast-tech.com。等待拉取数据...</p>`;
    }
}

var __syncSource = 'overview';

function triggerAlibabaSync(source) {
    __syncSource = source || 'overview';
    if (window.isSyncing) return;
    window.isSyncing = true;
    window.__efastSyncInProgress = true;

    const btn = document.getElementById("btn-sync-alibaba");
    const consoleLog = document.getElementById("sync-console-log");

    if (btn) {
        btn.innerHTML = `<i class="fas fa-spinner fa-spin"></i> 正在拉取...`;
        btn.disabled = true;
    }
    // 第一步：不再提前清空 localStorage，旧数据保留至新数据到达后再覆盖
    // 数据持久化：刷新页面不会丢失订单，只有同步成功后才会更新
    if (consoleLog) {
        consoleLog.innerHTML = `<p class="console-line">[${new Date().toLocaleTimeString()}] 同步任务已启动，保留既有数据，正在唤醒插件...</p>`;
    }
    if (consoleLog) {
        const p = document.createElement("p");
        p.className = "console-line";
        p.innerHTML = `[${new Date().toLocaleTimeString()}] 保留既有缓存数据，开始抓取最新订单...`;
        consoleLog.appendChild(p);
    }

    // 第二步：立即清空当前已渲染的 DOM 卡片（仅清理页面展示，不影响 localStorage）
    const todoList = document.getElementById("workbench-todo-list");
    if (todoList) todoList.innerHTML = '';
    
    if (consoleLog) {
        const p = document.createElement("p");
        p.className = "console-line";
        p.innerHTML = `[${new Date().toLocaleTimeString()}] 页面展示已刷新，正在唤醒插件抓取...`;
        consoleLog.appendChild(p);
    }

    // 第三步：触发插件扫描
    // 使用 postMessage 握手标志（_efastBridgeReady），避免跨沙箱 window 隔离问题
    const doScan = () => {
        var currentUser = null;
        if (typeof Auth !== "undefined" && Auth.getUser) {
            var u = Auth.getUser() || {};
            currentUser = {
                username: u.username || "",
                displayName: u.displayName || "",
                alibabaAlias: u.alibabaAlias || ""
            };
        }
        window.postMessage({ source: "efast_workbench_request", type: "SCAN_NOW", currentUser: currentUser }, "*");
    };

    if (window._efastBridgeReady) {
        doScan();
    } else {
        // bridge 尚未发来握手信号，轮询等待最多 5 秒
        let waited = 0;
        const poll = setInterval(() => {
            waited += 200;
            if (window._efastBridgeReady) {
                clearInterval(poll);
                doScan();
            } else if (waited >= 5000) {
                clearInterval(poll);
                window.isSyncing = false;
                window.__efastSyncInProgress = false;
                if (btn) { btn.innerHTML = `<i class="fas fa-cloud-arrow-down"></i> 实时拉取最新数据`; btn.disabled = false; }
                if (consoleLog) {
                    const p = document.createElement("p");
                    p.className = "console-line error";
                    p.innerHTML = `[${new Date().toLocaleTimeString()}] 未检测到插件！请确认：① 插件已加载 ② 重新刷新本页面 ③ 若仍不行，大概率是插件版本过旧（需 ≥ ${__latestExtensionVersion || "1.6.0"}）：旧版插件不支持云端域名，请更新插件后重试。`;
                    consoleLog.appendChild(p);
                    consoleLog.scrollTop = consoleLog.scrollHeight;
                }
            }
        }, 200);
    }

    // 第四步：启动加载进度提示（每 5 秒输出一次）
    __efastProgressInterval = setInterval(() => {
        if (!window.isSyncing) return;
        if (consoleLog) {
            const p = document.createElement("p");
            p.className = "console-line";
            p.innerHTML = `[${new Date().toLocaleTimeString()}] 正在加载中，请耐心等待...`;
            consoleLog.appendChild(p);
            consoleLog.scrollTop = consoleLog.scrollHeight;
        }
    }, 5000);

    // 第五步：设置 60 秒超时兜底，防止插件无响应时按钮永久锁死
    window.__efastSyncTimer = setTimeout(() => {
        if (!window.isSyncing) return;
        clearInterval(__efastProgressInterval);
        __efastProgressInterval = null;
        window.isSyncing = false;
        window.__efastSyncInProgress = false;
        if (btn) { btn.innerHTML = `<i class="fas fa-cloud-arrow-down"></i> 实时拉取最新数据`; btn.disabled = false; }
        if (consoleLog) {
            const p = document.createElement("p");
            p.className = "console-line error";
            p.innerHTML = `[${new Date().toLocaleTimeString()}] 同步超时（60秒）。请确认阿里后台标签页已打开并处于登录状态。`;
            consoleLog.appendChild(p);
            consoleLog.scrollTop = consoleLog.scrollHeight;
        }
    }, 60000);
}

// 供 workbench_bridge.js 调用：插件写完数据后主动触发此函数完成渲染
async function onSyncComplete(orderCount, scannedIds) {
    if (window.__efastSyncTimer) {
        clearTimeout(window.__efastSyncTimer);
        window.__efastSyncTimer = null;
    }
    if (__efastProgressInterval) {
        clearInterval(__efastProgressInterval);
        __efastProgressInterval = null;
    }
    window.isSyncing = false;
    syncCompleted = true;
    window.__efastSyncInProgress = false;

    const btn = document.getElementById("btn-sync-alibaba");
    const consoleLog = document.getElementById("sync-console-log");

    if (btn) {
        btn.innerHTML = `<i class="fas fa-check-circle"></i> 同步完毕`;
        btn.style.backgroundColor = "#10b981";
        setTimeout(() => {
            btn.innerHTML = `<i class="fa-solid fa-cloud-arrow-down"></i> 同步国际站订单`;
            btn.style.backgroundColor = "";
            btn.disabled = false;
        }, 3000);
    }

    // 等待全部订单落库后再清洗和渲染
    if (consoleLog) {
        const p = document.createElement("p");
        p.className = "console-line success";
        p.innerHTML = `[${new Date().toLocaleTimeString()}] 同步完成！已推送 ${orderCount} 条待发货订单，等待落库...`;
        consoleLog.appendChild(p);
        consoleLog.scrollTop = consoleLog.scrollHeight;
    }

    // 2026-10-17（修复）：REAL_ORDER 的「业务员别名映射 / 产品映射」都是异步的，必须等全部完成再取批次。
    //   原来这里没有 await → 页面每次刷新后的【第一次同步】，_pendingSyncOrders 还是空数组 →
    //   直接跳过 syncBatch（服务端 logs/sync-batch.log 里连请求都没有），插件抓到的订单全部静默丢失。
    try { await Promise.allSettled(_syncPendingPromises); } catch (e) {}
    _syncPendingPromises = [];

    var batchOrders = _pendingSyncOrders.slice();
    _pendingSyncOrders = [];
    _pendingSyncSaves = [];

    for (var bi = 0; bi < batchOrders.length; bi++) {
        batchOrders[bi].source = batchOrders[bi].source || __syncSource;
    }

    if (batchOrders.length > 0) {
        try { await syncBatch(batchOrders, scannedIds || []); } catch(e) { console.error("syncBatch failed:", e); }
    }
    // 2026-10-17（修复配套）：插件推了但一条都没进批次 → 必须可见，不再静默丢单
    if (orderCount > 0 && batchOrders.length === 0) {
        _showSyncToast('插件推送了 ' + orderCount + ' 条，但页面一条都没进批次（本次未落库）；请把控制台内容发给 Samson', 'error');
    }
    if (window.__efastSkippedOthers) {
        _showSyncToast('已跳过 ' + window.__efastSkippedOthers + ' 条非本人订单（归属人不是当前登录账号）', 'warn');
        window.__efastSkippedOthers = 0;
    }

    if (consoleLog) {
        const p = document.createElement("p");
        p.className = "console-line success";
        p.innerHTML = `[${new Date().toLocaleTimeString()}] 影子对齐清洗完成，正在重新渲染...`;
        consoleLog.appendChild(p);
        consoleLog.scrollTop = consoleLog.scrollHeight;
    }

    await loadStoredSalesData();
    var newCount = _syncNewCount; var updCount = _syncUpdateCount; _syncNewCount = 0; _syncUpdateCount = 0;
    var toastMsg = "同步完成！共 " + (newCount+updCount) + " 条，新增 " + newCount + " 条，更新 " + updCount + " 条";
    _showSyncToast(toastMsg, "info");
}

function submitRfQ(title) {
    alert(`🚀 抢单报价已成功提交！\n\n专案主题: ${title}\nAI 报价方案已直接灌入阿里巴巴 RfQ 报盘中心，等待客户回复。`);
}

window.handleExtensionEvent = handleExtensionEvent;
function handleExtensionEvent(payload) {
    if (!payload || !payload.type) return;

    // 强拦截警告：若业务员停留在“所有订单页”导致数据不全，强行中断，并弹出红色警示。
    if (payload.type === "NOT_ON_READY_TO_SHIP_TAB") {
        if (window.__efastSyncTimer) {
            clearTimeout(window.__efastSyncTimer);
            window.__efastSyncTimer = null;
        }
        if (__efastProgressInterval) {
            clearInterval(__efastProgressInterval);
            __efastProgressInterval = null;
        }
        window.isSyncing = false;
        window.__efastSyncInProgress = false;
        
        const btn = document.getElementById("btn-sync-alibaba");
        if (btn) {
            btn.innerHTML = `<i class="fa-solid fa-cloud-arrow-down"></i> 同步国际站订单`;
            btn.style.backgroundColor = "";
            btn.disabled = false;
        }
        
        const consoleLog = document.getElementById("sync-console-log");
        if (consoleLog) {
            const p = document.createElement("p");
            p.className = "console-line error";
            p.style.color = "#ef4444";
            p.style.fontWeight = "bold";
            p.innerHTML = `[${new Date().toLocaleTimeString()}] ⚠️ 警告：同步中断！检测到您当前未处于“准备发货”列表页。请在 Chrome 中切换到“准备发货”标签页，然后重新点击同步！`;
            consoleLog.appendChild(p);
            consoleLog.scrollTop = consoleLog.scrollHeight;
        }
        alert("⚠️ 警告：同步中断！\n\n检测到您当前未处于“准备发货”列表页。\n\n请在 Chrome 浏览器中点击切换到“准备发货”标签，然后再重新点击同步！");
        return;
    }

    // 收到清除指令：仅清空页面 DOM 展示，不删除 localStorage 缓存
    // 旧数据保留在 localStorage 中，等新数据到达后由 saveOrderToServer 覆盖/追加
    if (payload.type === "CLEAR_LOCAL_STORAGE") {
        console.log("[Efast Workbench] 收到插件清除指令，仅清理页面展示，保留 localStorage 缓存...");
        _pendingSyncSaves = [];
        // 清理当前已渲染的卡片，准备接收新数据
        const todoList = document.getElementById("workbench-todo-list");
        if (todoList) todoList.innerHTML = '';
                return;
    }

    if (payload.type === "REAL_ORDER") {
        var _promise = window.mapAliasToDisplayName(payload.salesperson).then(function(mapped) { payload.salesperson = mapped; var myName = (typeof Auth !== 'undefined' && Auth.getDisplayName) ? Auth.getDisplayName() : ''; if (myName && mapped !== myName) { console.warn('[Efast Sync] 跳过非本人订单: ' + payload.id + ' 归属: ' + mapped + ' ≠ 本人 ' + myName); window.__efastSkippedOthers = (window.__efastSkippedOthers || 0) + 1; return; } payload.source = __syncSource; return applyProductMappings(payload).then(function() { payload.source = __syncSource; _pendingSyncOrders.push(payload); _syncNewCount++; }); }); _syncPendingPromises.push(_promise);
        flashGlobalNotification();
    } else if (payload.type === "CORRECTION_ORDER") {

        // 纠错数据合并：保留列表页提取的 daysLeft/shipDate，仅更新产品/买家/金额
        var existing = allOrders.find(function(o) { return o.id === payload.order.id; });
        if (existing) {
            payload.order.daysLeft = existing.daysLeft;
            payload.order.shipDate = existing.shipDate;
        }
        payload.order.source = __syncSource; saveOrderToServer(payload.order).then(function() {
            return loadStoredSalesData();
        }).then(function() {
            alert('🎉 订单号: ' + payload.order.id + ' 纠错同步成功！\n\n产品规格、单价及负责人 "' + (payload.order.salesperson || '') + '" 已成功从详情页强制更新还原！');
        }).catch(function(e) {
            console.error('[Efast Store] 纠错保存失败:', e);
        });
        flashGlobalNotification();
        // 如果是普通旺旺消息，实时追加到 TM 消息对话框中
        if (chatData[payload.buyerName] || chatData.Dieter) {
            const targetChat = chatData[payload.buyerName] ? payload.buyerName : "Dieter";
            
            chatData[targetChat].messages.push({
                type: "incoming",
                text: payload.message,
                time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
            });
            
            // 如果处于当前聊天框，重新渲染
            if (currentChatId === targetChat) {
                renderChatMessages();
            }
            
            // 更新最后一条消息的文本
            const threadMsg = document.querySelector(`#thread-${targetChat.toLowerCase()} .last-msg`);
            if (threadMsg) threadMsg.innerText = payload.message;
        }
    }
}




// window bridges for template onclick handlers
window.triggerAlibabaSync = triggerAlibabaSync;
window.syncForOverview = syncForOverview;
window.syncForProject = syncForProject;
function syncForOverview() { triggerAlibabaSync('overview'); }
function syncForProject() { triggerAlibabaSync('project'); }


(function(){if(document.getElementById("sync-toast-style"))return;var s=document.createElement("style");s.id="sync-toast-style";s.textContent="@keyframes syncToastIn{from{transform:translateX(100px);opacity:0}to{transform:translateX(0);opacity:1}}";document.head.appendChild(s)})();

export { initAlibabaSync, onSyncComplete, syncForOverview, syncForProject };
